@let includeInactiveTeams = (includeInactiveTeams$ | async) ?? false;

@if (childTeams$ | async; as childLocations) {
    @if (team$ | async; as team) {
        @let teamIsInactive = !team.isActive();
        <div class="d-flex flex-grow-1 hover-container gap-2"
             [class.opacity-75]="teamIsInactive">
            <div class="d-flex flex-grow-1 align-items-center gap-1">
                <adapt-link-team [team]="team"
                                 [showIcon]="true"
                                 [showLabels]="false"
                                 [filterTeams]="filterTeams"
                                 [showChildCount]="showChildCount"></adapt-link-team>
                <adapt-team-inactive-badge [team]="team"
                                           [hasActiveChildren]="teamHasChildren(team.teamId)"></adapt-team-inactive-badge>
            </div>
            <div class="d-flex flex-row align-items-center align-self-start">
                @if (isEditing) {
                    <adapt-menu [items]="itemMenu"
                                [showOnHover]="true"
                                (visibleChanged)="menuVisible = $event"
                                class="mx-2 mt-1 hover-action"
                                [class.hover-action-visible]="menuVisible"
                                data-test="team-card-menu"></adapt-menu>
                }
                @if (showChildren && (childLocations.length > 0 || isEditing)) {
                    <span (click)="childrenExpanded = !childrenExpanded"
                          [adaptTooltip]="getCollapseTooltip(childLocations.length)"
                          adaptStopPropagation
                          class="expand-children"
                          data-test="expand-child-teams">
                        <i class="fa"
                           [ngClass]="childrenExpanded ? 'fa-chevron-up': 'fa-chevron-down'"></i>
                    </span>
                }
                @if (level < 3) {
                    <adapt-link-person [person]="team.teamLeaderPerson"
                                       [imageOnly]="true"
                                       imageSize="sm"
                                       [showPopover]="!isEditing"></adapt-link-person>
                }
                @if (isEditing && !teamIsInactive) {
                    <div class="dx-list-item-after-bag dx-list-reorder-handle-container">
                        <div #reorderHandle
                             class="dx-list-reorder-handle"></div>
                    </div>
                }
            </div>
        </div>

        @if (team.labelLocations?.length) {
            <div class="d-flex flex-row align-items-start gap-1 mt-2">
                <adapt-display-labels class="ms-1"
                                      [labelLocations]="team.labelLocations"></adapt-display-labels>
            </div>
        }

        @if (teamContentTemplate) {
            <ng-container *ngTemplateOutlet="teamContentTemplate; context: { $implicit: team, level: level }"></ng-container>
        }

        @if (showChildren && (childLocations.length > 0 || isEditing)) {
            <div #childrenContainer
                 [collapse]="!childrenExpanded"
                 [isAnimated]="true">
                @if (isEditing) {
                    <div class="children"
                         [class.is-editing]="isEditing"
                         [class.can-drop]="draggingTeamCanBeDroppedIntoParentTeam"
                         [class.cannot-drop]="!draggingTeamCanBeDroppedIntoParentTeam"
                         [nxtSortablejs]="undefined"
                         [config]="sortableOptions"
                         [attr.data-team-name]="team.name"
                         [attr.data-location]="'team-' + team.teamId"
                         [style.--team-level]="level"
                         data-test="team-card-children">
                        <ng-container *ngTemplateOutlet="childTeamLocationsTemplate"></ng-container>
                    </div>
                } @else {
                    <div class="children"
                         [attr.data-team-name]="team.name"
                         [attr.data-location]="'team-' + team.teamId"
                         [style.--team-level]="level"
                         data-test="team-card-children">
                        <ng-container *ngTemplateOutlet="childTeamLocationsTemplate"></ng-container>
                    </div>
                }

                <ng-template #childTeamLocationsTemplate>
                    @for (childTeamLocation of childLocations; track childTeamLocation.teamId) {
                        @if (childTeamLocation.team; as childTeam) {
                            <adapt-team-card [team]="childTeam"
                                             [class.inactive-team]="!childTeam.isActive()"
                                             [teamLocation]="childTeamLocation"
                                             [includeInactiveTeams]="includeInactiveTeams"
                                             [showChildren]="true"
                                             [childrenExpanded]="(!currentViewLevel || currentViewLevel > level + 1) && teamHasChildren(childTeamLocation.teamId, includeInactiveTeams)"
                                             [isEditing]="isEditing"
                                             [level]="level + 1"
                                             [currentViewLevel]="currentViewLevel"
                                             [teamContentTemplate]="teamContentTemplate"
                                             [filterTeams]="filterTeams"
                                             [parentBackground]="compositedBackground"></adapt-team-card>
                        }
                    }
                </ng-template>
            </div>
        }
    }
}
